/*
 * File: addressUser.ts
 * Project: meki
 * File Created: Friday, 2nd October 2020 5:42:52 pm
 * Author: Luis Aparicio (luis@inventures.cl)
 * -----
 * Last Modified: Friday, 2nd October 2020 5:43:51 pm
 * Modified By: Luis Aparicio (luis@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */
import { gql } from '@apollo/client';

export const AddressUserFragment = gql`
  fragment AddressUser on Address {
    uuid
    user {
      uuid
      name
      email
      rut
    }
  }
`;
